import {
  CancelAction,
  DangerAction,
  H2,
  gaps,
  margins,
  paddings,
  radii,
} from '@ohgoodlord/design-system'
import { BaseSyntheticEvent, useRef, useState } from 'react'
import styled from 'styled-components'

export interface Props {
  title: string
  description?: React.ReactNode
  confirmText?: string
  onSubmit: () => void
  onClose: () => void
}

const StyledWrapper = styled.div`
  display: block;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: ${paddings.m};
  background: rgba(0, 0, 0, 0.8);
  z-index: 999;

  .confirmation {
    position: absolute;
    top: 50%;
    left: 50%;
    width: calc(100% - ${paddings.m} - ${paddings.m});
    min-height: 150px;
    transform: translate(-50%, -50%);
    background: white;
    border-radius: ${radii.l};
    padding: ${paddings.m};

    @media (min-width: 768px) {
      width: 450px;
    }
  }
`

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${gaps.s};
  margin-bottom: ${margins.s};
`

const StyledActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${gaps.s};

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: flex-start;
  }
`

export const EditConfirmation = ({
  title,
  description,
  confirmText,
  onSubmit,
  onClose,
}: Props) => {
  const modalRef = useRef<HTMLDivElement | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleClickOutside = (e: BaseSyntheticEvent) => {
    if (modalRef.current !== null && !modalRef.current.contains(e.target) && !isLoading) {
      onClose()
    }
  }

  const handleOnSubmit = () => {
    setIsLoading(true)
    setTimeout(() => {
      setIsLoading(false)
      onSubmit()
    }, 2000)
  }

  return (
    <StyledWrapper onClick={handleClickOutside} data-testid="edit-confirmation-wrapper">
      <div className="confirmation" ref={modalRef} aria-label="Edit Section Confirmation">
        <StyledContent>
          <H2>{title}</H2>
          {description && <div>{description}</div>}
        </StyledContent>
        <StyledActions>
          <DangerAction onClick={handleOnSubmit} loading={isLoading}>
            {confirmText || 'Confirm'}
          </DangerAction>
          <CancelAction onClick={onClose} disabled={isLoading}>
            Cancel
          </CancelAction>
        </StyledActions>
      </div>
    </StyledWrapper>
  )
}
